export const KWIFFED_ANIMATION_CLOSE_AFTER = 3000;

export const AUTO_OPEN_TRENDING_BETS_AFTER = 4000;

export const PREVENT_AUTOMATIC_TB_OPENING_FOR = 20000;

export const MOODBAR_SPEED_CORRECTION_FACTORS = {
  minScore: 0,
  maxScore: 1,
  minSpeed: 0.5,
  maxSpeed: 3,
};

export const DEFAULT_MS_WAIT_TIME = 500;

export const MULTI_BET_STAKE_SUGGESTION_WAIT_TIME = 1200;

export const LONG_TOUCH_MIN_SECONDS = 0.5;

export const DEFAULT_RETRY_INTERVAL = 1000;

export enum TIMEOUT_MS {
  ASAP = 0,
  EXTRA_SHORT = 200,
  VERY_SHORT = 300,
  SHORT = 500,
  MEDIUM = 800,
  BIG = 1000,
  VERY_BIG = 2000,
}

export const TOKEN_RENEW_AFTER_TIME = 15 * 60 * 1000; // milliseconds

// we force updates every second, starting 10 minutes and 5 seconds before the event goes live.
// the 5 seconds are a margin for error
export const EVENT_COUNTDOWN_START_BEFORE_SEC = 605;

export const PLACE_BET_BROADCAST_RESPONSE_TIMEOUT = 8000;
